module.exports = "<div id='login-dialog'>\r\n  <div id = 'login-message'></div>\r\n</div>\r\n"